// src/contexts/ModalContext.js
import React, { createContext, useState, useContext } from 'react';
import Modal from '../components/common/Modal';
import ConsultationForm from '../components/form/ConsultationForm';
import MentorForm from '../components/form/MentorForm';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [consultationModalOpen, setConsultationModalOpen] = useState(false);
  const [mentorModalOpen, setMentorModalOpen] = useState(false);

  const openConsultationModal = () => {
    setConsultationModalOpen(true);
  };

  const closeConsultationModal = () => {
    setConsultationModalOpen(false);
  };

  const openMentorModal = () => {
    setMentorModalOpen(true);
  };

  const closeMentorModal = () => {
    setMentorModalOpen(false);
  };

  return (
    <ModalContext.Provider
      value={{
        openConsultationModal,
        closeConsultationModal,
        openMentorModal,
        closeMentorModal
      }}
    >
      {children}
      
      {/* 교육상담 신청 모달 */}
      <Modal 
        isOpen={consultationModalOpen} 
        onClose={closeConsultationModal}
        title="교육상담 신청"
      >
        <ConsultationForm onSubmitSuccess={closeConsultationModal} isModal={true} />
      </Modal>
      
      {/* 멘토 신청 모달 */}
      <Modal 
        isOpen={mentorModalOpen} 
        onClose={closeMentorModal}
        title="스터디 멘토 신청"
      >
        <MentorForm onSubmitSuccess={closeMentorModal} isModal={true} />
      </Modal>
    </ModalContext.Provider>
  );
};